export function Facebook() {
  return (
    <span className="anticon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_1"
        data-name="Layer 1"
        viewBox="0 0 64 64"
        width="64"
        height="64"
      >
        <title>{'icon-fa'}</title>
        <path
          d="M0,57.33V6.65A6.67,6.67,0,0,1,6.67,0H57.35A6.67,6.67,0,0,1,64,6.65V57.33A6.67,6.67,0,0,1,57.35,64H42.68V40h8l2-10.67h-10l.24-5.47c0-2.64.72-4.19,4.29-4.19h5.65l1.28-9.55s-6.05-.8-9.63-.8c-8,0-12.67,5.36-12.67,13.58L32,29.33H24V40h8V64H6.67A6.67,6.67,0,0,1,0,57.33Z"
          fill="currentcolor"
        />
      </svg>
    </span>
  );
}
